// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2jvrK","savePackageButton":"ClientWallet_savePackageButton__3en4z"};